import { useApi } from "utils/hooks/use-api";
import styles from "./app-logs.module.scss";
import React, { useEffect, useState } from "react";
import PageTitle from "components/shared-ui/pageTitle";
import RefreshButton from "components/shared-ui/button/refresh-button";
import {
  IAppLogPageRequestParams,
  ILogInfoListResponse,
} from "api/entities/logs";
import { logService } from "api/services/logs";
import { AppLogTable } from "./app-logs-table";
import { getDefaultRequestParams } from "redux/reducers/entity";
import { IQueryStrictParams } from "api/entities/page";
import { FiltersBar } from "components/shared-ui/filters-bar/filters-bar";
import { CompactViewScreen } from "components/shared-ui/common/component-props";

const EMPTY_LIST: ILogInfoListResponse = {
  data: [],
  limit: 0,
  total: 0,
  offset: 0,
};

export default function AppLogs() {
  const [logsApi, isLogsLoading] = useApi();
  const [logsList, setLogsList] = useState<ILogInfoListResponse>(EMPTY_LIST);
  const [requestParams, setRequestParams] = useState<IAppLogPageRequestParams>({
    ...getDefaultRequestParams(),
  });

  const requestData = (params: Partial<IAppLogPageRequestParams>) => {
    const updatedParams = { ...requestParams, ...params };
    setRequestParams(updatedParams);
    logsApi(
      logService.getLogs(updatedParams).then((logs) => {
        setLogsList(logs);
        return logs;
      }),
    );
  };

  useEffect(() => {
    requestData(requestParams);
  }, []);

  return (
    <>
      <div className={styles.header}>
        <PageTitle title={`Logs`}>
          <RefreshButton onClick={() => requestData(requestParams)} />
        </PageTitle>
      </div>
      <FiltersBar
        testId="app-logs-filter-bar"
        searchValue={requestParams.q}
        onSearchValueChanged={(searchText) => requestData({ q: searchText })}
        compactViewScreen={CompactViewScreen.Medium}
      />

      <AppLogTable
        isLoading={isLogsLoading}
        page={logsList}
        setRequestParams={requestData}
        requestParams={requestParams}
      />
    </>
  );
}
